export default {
  //Bad Place for This information (session Storage is proper place) [Refactory]
  token: sessionStorage.getItem('user-token')
    ? JSON.parse(sessionStorage.getItem('user-token'))
    : {
        code: '',
        id_token: '',
        access_token: '',
        token_type: '',
        expires_in: '',
        expires_time: '',
        scope: '',
        session_state: '',
        refresh_token: '',
      },
  lastUserInteractionDate: new Date().getTime(),
  isLoggingOut: sessionStorage.getItem('isLoggingOut')
    ? JSON.parse(sessionStorage.getItem('isLoggingOut'))
    : false,

  //This is Search Component
  navigateToViewRoute: '',
  navigateToViewCard: '',
  navigateToViewDisplay: false,
  //This Module  [Refactory] (Temporal Fix) [The real fix take more time -_- ]
  userProfile: sessionStorage.getItem('user-profile')
    ? JSON.parse(sessionStorage.getItem('user-profile'))
    : {
        user: {
          role: '',
          roleid: '',
          givenname: '',
          firstname: '',
          lastpaternalname: '',
          userlocation: '',
          activeflag: '',
          isapproved: '',
          islockedout: '',
          aduserflag: '',
          sieuserflag: '',
          idp: '',
          sub: '',
          name: '',
          email: '',
          lastLogin: '',
          permissions: [],
          centerId: null,
          pilotPlan: false,
        },
      },
  sitemap: sessionStorage.getItem('user-siteMap')
    ? JSON.parse(sessionStorage.getItem('user-siteMap'))
    : [],

  webServiceStudentSearchEnabled: false,
  selectedStudentMustHaveRegistration: false,
  studentId: 0,
  oldstudentId: 0,
  searchedStudentHistory: [],
  //Student this information is module
  ProvisionalRemedyRequest: {
    name: null,
    sie: null,
    evaluationType: null,
    discipline: null,
    applicationDate: null,
    studentReferralId: null,
    disciplineTypeId: null,
    AcademicYearId: null,
  },
  placementCommittee: null,
  //Pei
  ProvisionalRemedyRequestRef: {
    name: null,
    sie: null,
    disciplineName: null,
    modalityTypeName: null,
    frequecy: null,
    duration: null,
  },
  peiSelected: sessionStorage.getItem('peiSelected')
    ? JSON.parse(sessionStorage.getItem('peiSelected'))
    : null,
  pei: {
    peiStatusCode: null,
    peiStatusCodeDescription: null,
    peiLocationRejected: null,
    configUnilateralFlag: 0,
    prescholarFlag: 0,
    extendedSchoolYearFlag: 0,
    otherServTechAssistEquipFlag: 0,
    academicYearId: 0,
    previousPeiId: 0,
    // PEI controversy list.
    controversies: null,
    transitionServicesFlag: '0',
    ageAmt: null,
    checklistStatusCode: null,
    showSignatureCancellationDocument: false,
    isDigitalSignatureCancelled: false,
    tab10IsEnabled: false,
  },
  peiATAmmendment: false,
  peiHasAcademicAreas: false,
  peiHasAlternativeAcademicUbications: null,
  //At
  atSelected: sessionStorage.getItem('atSelected')
    ? JSON.parse(sessionStorage.getItem('atSelected'))
    : null,
  atSaveBtnDisabled: false,
  // Alert Modal for required selected student
  showRequiredStudentModal: false,
  //Tabs for selected evaluation answer
  preEvaluationAnswer: false,
  recentlyEvaluatedBy: 0,
  //for validations AT
  atValidationTriggered: {
    validation: false,
  },
  activeEducationalCompensatoryService: false,
  studentTherapies: [],
  tab: {
    saveMethod: function() {},
    registerMethod: function() {},
    changeInitEvaluationMethod: function() {},
    currentFormDirty: false,
    resetMethod: null,
    resetOriginalDataMethod: null,
    showSaveBtn: false,
  },
  peiTab1: {
    showSignSection: false,
    signSectionVisibles: [],
  },
  peiTab10: {
    isSignedPeiParameterEnable: false,
    isCompuFileParameterEnable: false,
  },
  atCompleted: false,
  activeATTab: {
    Id: '',
    object: {},
  },
  // Pei Affirmative Letter
  peiAffirmativeLetterSelected: null,
  serviceTypeId: 0,
  regStudentId: 0,
  //for validations PEI
  peiValidationTriggered: {
    validation: false,
  },
  // Pei Analisys Services
  peiTransportationInfo: null,
  analysisServiceId: 0,
  areaExtendedSelected: null,
  parentsRouter: [],
  studentSave: function() {},
  resetStudent: function() {},
  peiTab2: {
    peiId: '',
    evaluationAnalysisDate: null,
    evaluationTriannualDate: null,
    generalImpedimentDescription: '',
    hasResultSummary: false,
    resultSummaryAnalysisServiceIds: [],
  },
  exit: null,
  flagPreregister: [],
  compensatoryServicesValidation: [],
  resultSummaryValidation: [],
  componentsValidated: {},
  isNavOpen: true,
  isMobileDensity: false,
  // Estado del panel docked del Asistente de IA del PEI (ver AiAssistantModal.vue) --
  // true mientras el panel está abierto en modo docked, para que Layout.vue pueda
  // angostar el área de contenido principal.
  aiAssistantDocked: false,
  // 15 sep -- último modo ('small' | 'docked' | 'fullscreen') que el especialista eligió en
  // CUALQUIER diálogo del Asistente de IA del PEI. Antes cada AiAssistantModal.vue arrancaba
  // siempre en 'small' sin importar el modo anterior -- rompía la cadena "Meta con Asistente
  // IA" -> "Objetivo con Asistente IA" (AG-05): si el especialista anclaba ("pineaba") el
  // diálogo de Metas al panel derecho, el de Objetivos que se abre solo a continuación volvía
  // a aparecer flotante. Vive en Vuex (no en el propio componente) justamente porque cada
  // diálogo de IA es una instancia de Vue distinta -- así el siguiente lee la preferencia del
  // anterior en vez de arrancar en blanco.
  aiAssistantPreferredMode: 'small',
  rlvEvidenceReportParams: null,
  postRegistryState: {},
  showEditionCallaout: false,
  afterConfirmAppoinmentMethod: function() {},
  userHasValidRole: null,
  showRefreshSignatureTab: false,
  justSaveTab10: false,
  showDigitalSignatureActions: false,
  requireUsageGuaranteeCompletionEnabled: false,
  bypassStudentChangeAlert: null,
  signatureDocument: {},
  tab10SignatureInfo: {
    isPSSignatureFilesFlag: null,
    isElectronicSignature: null,
  },
  triannualEvaluation: null,
  registryTriannualEvaluation: null,
  registryTriannualEvaluationList: null,
};
